import { InteractionType } from '@azure/msal-browser';

interface AuthResponseLocation {
  hash: string;
  search: string;
}

export function getMsalInteractionType(
  location: AuthResponseLocation,
): InteractionType | null {
  const hashParams = new URLSearchParams(location.hash.slice(1));
  const queryParams = new URLSearchParams(location.search.slice(1));
  const stateRaw = hashParams.get('state') ?? queryParams.get('state');
  if (!stateRaw) return null;

  try {
    const libraryState = stateRaw.split('|', 1)[0];
    if (!libraryState) return null;
    const parsed = JSON.parse(atob(libraryState)) as {
      meta?: { interactionType?: string };
    };
    const type = parsed.meta?.interactionType;
    if (type === InteractionType.Popup) return InteractionType.Popup;
    if (type === InteractionType.Redirect) return InteractionType.Redirect;
    if (type === InteractionType.Silent) return InteractionType.Silent;
  } catch {
    // The state belongs to another flow or is malformed.
  }

  return null;
}
